<template>
  <v-stepper v-model="localStepperCount" class="w-75" alt-labels linear flat>
    <v-stepper-header class="h-100 overflow-hidden">
      <v-stepper-item
        :complete="appStore.stepperCount > 0"
        value="1"
        :color="appStore.stepperCount >= 0 ? 'primary' : ''"
        class="justify-center"
      >
        {{ $t('messages.mode') }}
      </v-stepper-item>

      <v-divider
        :style="{
          'border-color': appStore.stepperCount > 0 ? 'rgb(var(--v-theme-primary))' : '',
        }"
        class="my-0 justify-center align-self-center pa-4"
      />

      <v-stepper-item
        :complete="appStore.stepperCount > 1"
        value="2"
        class="justify-center"
        :color="appStore.stepperCount >= 0 ? 'primary' : ''"
      >
        {{ $t(appStore.selectedDesignFlow.stepperActionLabel) }}
      </v-stepper-item>

      <v-divider
        :style="{
          'border-color': appStore.stepperCount > 1 ? 'rgb(var(--v-theme-primary))' : '',
        }"
        class="my-0 justify-center align-self-center pa-4"
      />

      <v-stepper-item
        :complete="appStore.stepperCount > 2"
        value="3"
        :color="appStore.stepperCount >= 0 ? 'primary' : ''"
        class="justify-center"
      >
        {{ $t('messages.creative') }}
      </v-stepper-item>
    </v-stepper-header>
  </v-stepper>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

const localStepperCount = computed(() => appStore.stepperCount)
</script>

<style scoped>
:deep(.v-stepper-item--complete .v-stepper-item__content),
:deep(.v-stepper-item--selected .v-stepper-item__content) {
  color: rgb(var(--v-theme-primary)) !important;
}
:deep(.v-divider) {
  border-width: medium 0 0 0 !important;
}
:deep(.v-avatar) {
  margin-bottom: 2px !important;
}
</style>
